import { createZodDto } from 'nestjs-zod/dto';
import { z } from '@lucidlink/dto/z';
import { principalIdValidator } from '#validation';
import { groupCryptoSchema } from './group-create.dto';
const GroupCryptoUpdateSchema = z.array(groupCryptoSchema.extend({
    principalId: principalIdValidator({
        requiredError: 'group.principalId.required',
        formatError: 'group.principalId.uuid',
        forbiddenError: 'group.principalId.forbidden',
    }),
}));
export class GroupCryptoUpdateDto extends createZodDto(GroupCryptoUpdateSchema) {
}
